import type { AdmissionEnquiry, AdmissionEnquiryStatus } from '../../../types/admissions';
import type { ExportColumn } from '../../../utils/admissionRecords';
import type { PdfTone } from '../../../utils/pdf';
import { fmtClassName } from '../../../utils/pdf';
import { yearLabel } from '../../../utils/academicYear';
import dateTimeUtils from '../../../utils/dateTimeUtils';
import { statusLabel } from '../../common/StatusChip';
import { formatPhone } from '../form/admissionFormFields';

const date = (iso?: string | null): string => (iso ? dateTimeUtils.formatDateForDisplay(iso) : '');

/** How each status reads in print — as its chip does on screen. */
export const ENQUIRY_PDF_TONE: Record<AdmissionEnquiryStatus, PdfTone> = {
  new: 'neutral',
  called: 'primary',
  applied: 'success',
  not_interested: 'neutral',
};

/** Every column of the enquiries export, in order; the PDF prints those marked `pdf`. */
export const ENQUIRY_EXPORT_COLUMNS: Array<ExportColumn<AdmissionEnquiry>> = [
  { header: 'Child', width: 24, value: e => e.childName, pdf: { flex: 1.3 } },
  { header: 'Born', width: 14, value: e => date(e.dob), pdf: { width: 72 } },
  { header: 'Class', width: 12, value: e => fmtClassName(e.classId?.name ?? ''), pdf: { width: 52 } },
  { header: 'Year', width: 10, value: e => yearLabel(e.forYear), pdf: { width: 48 } },
  { header: 'Parent', width: 24, value: e => e.parentName, pdf: { flex: 1.2 } },
  { header: 'Phone', width: 15, value: e => formatPhone(e.parentPhone), pdf: { width: 88 } },
  { header: 'Status', width: 15, value: e => statusLabel({ kind: 'enquiry', value: e.status }), pdf: { width: 82 }, isStatus: true },
  { header: 'Called on', width: 13, value: e => date(e.calledAt) },
  { header: 'Note', width: 44, value: e => e.note || '', pdf: { flex: 2.2 } },
  { header: 'Added', width: 13, value: e => date(e.createdAt), pdf: { width: 72 } },
];
